// extracted by mini-css-extract-plugin
module.exports = {"more":"more_more__8G7ph","button":"more_button__7b_xi","buttonLabel":"more_buttonLabel__2C5N_","opened":"more_opened__2gh1r","moreWysiwyg":"more_moreWysiwyg__aSKWb"};